import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientProductsRoute } from '../route';

import { clientAccountsFilterFormSchema } from './components/ClientAccountsFilter/clientAccountsFilterFormSchema';

export const clientAccountsPageValidateSearchSchema = z.object({
	openedAccount: z.string().optional(),
	terminationProcessId: z.string().optional(),
	openedMobility: z.string().optional().catch(undefined),
	filter: clientAccountsFilterFormSchema.prefault({
		accountState: 'active',
	}),
	pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
	loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
});

export const clientAccountsRoute = createRoute({
	path: '/accounts',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientAccountsPage'),
		'ClientAccountsPage',
	),
	validateSearch: clientAccountsPageValidateSearchSchema,
});
